export class GetReCaptchaRequestModel {
    CaptchaKey: string;
  }
  